import normalizeStringValue from '@commons/utils/normalizeStringValue';

export const normalizeKeys = (object) =>
  Object.entries(object).reduce((acc, [key, value]) => {
    acc[key] = normalizeStringValue(value);
    return acc;
  }, {});
